import moment from "moment";
import React from "react";
import ShowDeliveryTime from "components/ShowDeliveryTime";

const RenderTime = ({ deliveryTime, orderPlacedtime }) => {
  const nowCopy = moment(moment().valueOf()); // keep your frozen "now"

  let diff;

  if (deliveryTime > 1000000000) {
    // It's a UNIX timestamp: calculate remaining minutes from nowCopy
    const deliveryMoment = moment.unix(deliveryTime);
    diff = deliveryMoment.diff(nowCopy, "minutes");
  } else {
    // It's an estimate in minutes remaining
    diff = parseFloat(deliveryTime);
  }

  return <ShowDeliveryTime val={diff} />;
};

export default RenderTime;

